import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'brackets-angle', 'BracketsAngle', [["path",{"d":"M8 4l-5 8l5 8"}],["path",{"d":"M16 4l5 8l-5 8"}]]);